<script>
import { required, email } from "vuelidate/lib/validators";
import Modal from "../../../../components/modals/modal-form.vue";
import api from '../../../../helpers/apirest/api';

import {
    roleComputed
} from "@/state/helpers";

const initialState = () => {
    return {
        submitted: false,
        user: {
            name: null,
            email: null,
            role_ids: []
        }
    };
}

export default {
    emits: ['onSuccess'],
    props: {
        modalId: String,
        id: Number
    },
    data() {
        return initialState();
    },
    components: {
        Modal
    },
    computed: {
        ...roleComputed,  
    },
    validations: {
        user: {
            name: { required },
            email: { required, email },
            role_ids: { required },
        }
    },
    methods: {
        async shown() {
            this.$store.dispatch("role/loadList");
            if (this.id) {
                const response = await api.get({
                    url: `users/${this.id}`
                });
                const data = response?.data?.data;
                data.role_ids = data?.roles?.map(item => (item?.id));
                this.user = response?.data?.data;
            }
        },
        async confirm() {

            this.submitted = true;
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            const data = this.user;

            await api.save({
                url: 'users',
                id: this.user?.id,
                data: data 
            });

            this.$bvModal.hide(this.modalId);
            this.$emit("onSuccess");
        },
        cancel() {
            this.$bvModal.hide(this.modalId);
        },
        resetModal() {
            Object.assign(this.$data, initialState());
        }
    }
};
</script>

<template>
    <Modal :title="'Custom title'" :id="modalId" @confirm="confirm" @cancel="cancel" @shown="shown" @hidden="resetModal">        
        <div class="form-group">
            <label for="name">Name</label>
            <input
                id="name"
                v-model="user.name"
                type="text"
                class="form-control"
                placeholder="Enter name"
                :class="{ 'is-invalid': $v.user.name.$error && submitted }"
            />
            <div v-if="!$v.user.name.required && submitted" class="invalid-feedback">Name is required</div>
        </div>
        <div class="form-group">
            <label for="email">Email</label>
            <input
                id="email"
                v-model="user.email"
                type="text"
                class="form-control"
                placeholder="Enter name" :class="{ 'is-invalid': $v.user.email.$error && submitted }"
            />
            <span v-if="!$v.user.email.required && submitted" class="invalid-feedback">Email is
                required.</span>
            <span v-else-if="!$v.user.email.email && submitted" class="invalid-feedback">Invalid email.</span>
        </div>
        <div class="form-group">
            <label for="role_ids">Roles</label>
            <select
                multiple
                v-model="user.role_ids"
                class="form-control"
                :class="{ 'is-invalid': $v.user.role_ids.$error && submitted }">
                <option v-for="option in roles" v-bind:value="option.id" :key="option.id">
                    {{ option.name }}
                </option>
            </select>
            <div v-if="!$v.user.role_ids.required && submitted" class="invalid-feedback">Roles is
                required</div>
        </div>
</Modal></template>